import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, packagingMaterialValidation } from "./packaging-material-schema";
import { createPackagingMaterial } from "services/data.internal.service";
import PackagingMaterialInfo from "./components/PackagingMaterialInfo";

function AddPackagingMaterial() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createPackagingMaterialMutation = useMutation(createPackagingMaterial, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(packagingMaterialValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    createPackagingMaterialMutation.mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };
  const createStatus = createPackagingMaterialMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <PackagingMaterialInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus}  url="/setup/packaging-material" />
      </form>
    </Layout>
  );
}

export default AddPackagingMaterial;
